<footer>
  Spectro 2021 All Rights Reserved | v.1.1
</footer>
